import {CameraMounted} from "../../../components/camera-mounted/CameraMounted";
import React, {PropsWithChildren, useRef} from "react";
import {useFrame, useThree} from "@react-three/fiber";
import * as THREE from "three";
import {Mesh} from "three";
import {Room} from "../../../interfaces/Room";
import {Text} from "@react-three/drei";

export type ARRoomManagerProps = {
    rooms: Room[];
};

export const ARRoomManager = (props: PropsWithChildren<ARRoomManagerProps>) => {

    const {camera} = useThree();
    const cameraActor = useRef<Mesh>();

    const distanceFromCamera = 0.6;
    const verticalAlignment = -0.15;

    const scale = 0.1;

    //
    // console.log("Room", scaledWidth, "x", scaledDeep);
    //
    // useEffect(() => {
    //     const timer = setInterval(() => {
    //         if (cameraActor.current) {
    //             console.log("camera", camera.position.x, "x", camera.position.z);
    //             console.log("actor", cameraActor.current.position.x, "x", cameraActor.current.position.z);
    //         }
    //     }, 1000);
    //
    //     return () => clearInterval(timer);
    // });

    useFrame(() => {
        if (cameraActor.current) {
            const actorPos = cameraActor.current.position;
            const camPos = camera.position;
            actorPos.x = camPos.x * scale;
            actorPos.z = (camPos.z * scale) - distanceFromCamera;
        }
    });

    // const rooms = props.rooms.map(room => {
    //
    //     // const vertices = room.vertices
    //     //     .map(({x, y, z}) => ([x, y, z]))
    //     //     .reduce((all: number[], current: number[]) => [...all, ...current], []);
    //
    //     // const float32Vertices = new Float32Array(vertices);
    //     //
    //     // const shape = room.vertices.map(({x, z}) => new Vector2(x, z));
    //     // console.log(shape);
    //     // const triangulatedShape: number[][] = THREE.ShapeUtils.triangulateShape(shape, []);
    //     // console.log(triangulatedShape);
    //     //
    //     // const v3Shape = triangulatedShape
    //     //     .map((index) => (room.vertices[index]))
    //     //     .reduce((all: number[], current: number[]) => [...all, ...current], []);
    //
    //
    //     // const itemSize = 3; // x, y, z
    //
    //     return (
    //         <group position={[0, verticalAlignment, -distanceFromCamera]} scale={[scale, scale, scale]}>
    //             {/*<mesh>*/}
    //             {/*    <bufferGeometry>*/}
    //             {/*        <bufferAttribute*/}
    //             {/*            attachObject={["attributes", "position"]}*/}
    //             {/*            count={room.vertices.length}*/}
    //             {/*            itemSize={itemSize}*/}
    //             {/*            array={float32Vertices}*/}
    //             {/*        />*/}
    //             {/*    </bufferGeometry>*/}
    //             {/*    <meshBasicMaterial color={"white"} side={THREE.DoubleSide} />*/}
    //             {/*</mesh>*/}
    //             <Text fontSize={0.3}>
    //                 {Math.ceil(room.area * 100) / 100} m2
    //             </Text>
    //         </group>
    //     );
    // });

    return (
        <>
            <CameraMounted>
                <group position={[0, verticalAlignment, -distanceFromCamera]} scale={[scale, scale, scale]}>
                    <Text fontSize={0.3}>
                        {Math.ceil(props.rooms[props.rooms.length - 1].area * 100) / 100} m2
                    </Text>
                </group>
                {/*<mesh position={[0, -0.15, -0.5]} rotation={[-Math.PI * 0.5, 0, 0]}>*/}
                {/*    <planeBufferGeometry args={[planeWidth, planeDeep]} />*/}
                {/*    <meshBasicMaterial color={"white"} />*/}
                {/*</mesh>*/}
                {/*{rooms}*/}
                {/*<mesh ref={cameraActor} position={[0, verticalAlignment + 0.02, -distanceFromCamera]}>*/}
                {/*    <boxBufferGeometry args={[0.003, 0.02, 0.003]} />*/}
                {/*    <meshBasicMaterial color={"red"} />*/}
                {/*</mesh>*/}
            </CameraMounted>
        </>
    );
};